import script from "./DepartmentPublicationsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentPublicationsTab.vue?vue&type=script&setup=true&lang=js"

import "./DepartmentPublicationsTab.vue?vue&type=style&index=0&id=10a824d9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10a824d9"]])

export default __exports__